/* eslint-disable class-methods-use-this */
export default class Menu {
  constructor() {
    this.elements = {
      subheaderTarget: document.querySelector('.js-header')
    };
    if (this.elements.subheaderTarget) {
      this.initSubHeader();
    }
  }

  initSubHeader() {
    const subHeaderTarget = this.elements.subheaderTarget.querySelector(
      '#submenu'
    );

    this.createSubMenu(subHeaderTarget);
  }

  createSubMenu(menuElement) {
    const mobileMenuSections = document.querySelectorAll('.section-header, .section--header');

    if (mobileMenuSections.length > 0) {
      mobileMenuSections.forEach((element) => {
        const find = `a[href = "#${element.id}"]`;
        if (menuElement && !menuElement.querySelector(find)) {
            menuElement.appendChild(this.createSubMenuItem(element));
        }
      });
    }
  }

  createSubMenuItem(element) {
    const li = document.createElement('li');
    const a = document.createElement('a');

    a.href = `#${element.id}`;
    a.setAttribute('class', 'link-clean');
    a.textContent = element.dataset.menuTitle;

    li.setAttribute('class', 'sub-header__link color--base-med');
    li.appendChild(a);

    return li;
  }

  handleScroll(element) {
    if (!element) { return; }

    const anchorTagsTargets = element.querySelectorAll('a');

    if (!anchorTagsTargets.length) { return; }

    anchorTagsTargets.forEach((link) => {
      link.addEventListener('click', (e) => {
        const container = document.body;
        const customEvent = new CustomEvent('makeTogglePassive', {
          detail: { toggleId: 'menu-toggle' }
        });
        container.dispatchEvent(customEvent);
        const id = e.target.getAttribute('href');
        const targetElement = document.getElementById(id.slice(1));
        container.scrollTop = targetElement.offsetTop;
      });
    });
  }
}
